import React from "react";
import { financeRows } from "../../../../data/workspaceData";
import { SectionHeader } from "../../common/WorkspaceChrome";

export function FinanceView() {
  return (
    <>
    <section className="panel">
      <SectionHeader
        eyebrow="Finance"
        title="Invoices, wallet, rewards, commissions, and project budget"
        text="Useful for client-service companies, training teams, interns, BDE/BDA payouts, and reward-led work."
      />
      <div className="finance-grid">
        {financeRows.map((row) => (
          <article key={row.label}>
            <span>{row.label}</span>
            <strong>{row.value}</strong>
            <small>{row.note}</small>
          </article>
        ))}
      </div>
    </section>
    </>
  );
}
